import { CardsSection } from '../../cardsSection';
import { RouterLink } from '../../../components/AcademyLinks';
import { WIZARD_URL_FRAGMENT } from '../../../constants/Navigation';
import UsageTracker from '../../../utils/UsageTracker';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useState } from 'react';
import RecommendationsResetModal from '../../../components/Recommendations/RecommendationsResetModal';
import Raven from 'raven-js';
import { useMlRecommendationsState } from '../recommendationsStore';
import { useMlRecommendationsContent } from 'academy-common-lib/features/recommendations/hooks/useMlRecommendationsContent';
import { usePostMlRecommendationsFeedback } from '../recommendationsQueries';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { InfoIcon } from 'foundations-assets/icons/components/InfoIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MlRecommendationsDescription = () => {
  const [isResetModalOpen, setIsResetModalOpen] = useState(false);
  const handleUpdateRecommendationsLinkClick = () => {
    UsageTracker.track('interaction', {
      action: 'ml-recommendations-reset-click'
    });
  };
  const handleUpdateRecommendationsInfoClick = () => {
    setIsResetModalOpen(true);
    UsageTracker.track('interaction', {
      action: 'ml-recommendations-info-click'
    });
  };
  const handleResetModalClose = () => {
    setIsResetModalOpen(false);
    UsageTracker.track('interaction', {
      action: 'ml-recommendations-info-closed'
    });
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.tracks.subheaders.personalRecommendations"
    }), /*#__PURE__*/_jsx(RouterLink, {
      className: "m-left-1",
      onClick: handleUpdateRecommendationsLinkClick,
      to: WIZARD_URL_FRAGMENT,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.tracks.resetLink.linkMessage"
      })
    }), /*#__PURE__*/_jsx(IconButton, {
      marginInlineStart: "-200",
      onClick: handleUpdateRecommendationsInfoClick,
      padding: "0",
      use: "transparent",
      children: /*#__PURE__*/_jsx(InfoIcon, {
        color: "icon-core-subtle",
        size: "200"
      })
    }), isResetModalOpen && /*#__PURE__*/_jsx(RecommendationsResetModal, {
      onClose: handleResetModalClose
    })]
  });
};
export const MlRecommendations = props => {
  const [maxCards, setMaxCards] = useState();
  const {
    content,
    loading,
    error,
    correlationId,
    recommendationStrategy
  } = useMlRecommendationsContent(maxCards);
  const {
    postMlRecommendationsFeedback
  } = usePostMlRecommendationsFeedback();
  const {
    setLastClickedRecommendationItem
  } = useMlRecommendationsState();
  const handleOnItemClick = ({
    id,
    type,
    language,
    name
  }, index) => {
    if (correlationId) {
      postMlRecommendationsFeedback({
        correlationId,
        entityType: type,
        entityId: id
      }).catch(Raven.captureException.bind(Raven));
      setLastClickedRecommendationItem({
        correlationId,
        item: {
          id,
          type: type
        }
      });
    }
    UsageTracker.track('interaction', {
      action: 'catalog-recommendation-card-click',
      cardNumber: index + 1,
      contentId: id,
      contentType: type,
      name,
      language: language,
      recommendationType: 'ml',
      recommendationStrategy
    });
  };
  return /*#__PURE__*/_jsx(CardsSection, Object.assign({
    appearsIn: "ml-recommendations",
    content: content,
    description: /*#__PURE__*/_jsx(MlRecommendationsDescription, {}),
    displayFullCardsOnMobile: false,
    error: error,
    header: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.tracks.headers.recommended"
    }),
    isLoading: loading,
    navMarker: !loading && !error ? 'HOMEPAGE_RECOMMENDATIONS_LOADED' : undefined,
    onItemClick: handleOnItemClick,
    setMaxCards: setMaxCards,
    size: "extra-large"
  }, props));
};
export default MlRecommendations;